// src/pages/Profile.js - 优化移动端版本
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
    const navigate = useNavigate();
    const [pushNotifications, setPushNotifications] = useState(true);
    const [locationSharing, setLocationSharing] = useState(true);

    const handleBack = () => {
        navigate('/features');
    };

    return (
        <>
            <style>{`
        .profile-container {
          width: 100%;
          max-width: 430px;
          height: 100vh;
          height: 100dvh;
          margin: 0 auto;
          background: #f5f5f5;
          display: flex;
          flex-direction: column;
          position: relative;
        }
        
        /* Header - 固定高度 */
        .profile-header {
          background: white;
          padding: 0;
          position: sticky;
          top: 0;
          z-index: 100;
          box-shadow: 0 1px 3px rgba(0,0,0,0.08);
        }
        
        .header-bar {
          display: flex;
          align-items: center;
          padding: 12px 16px;
          padding-top: max(12px, env(safe-area-inset-top));
        }
        
        .back-btn {
          width: 32px;
          height: 32px;
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #333;
        }
        
        .header-title {
          flex: 1;
          text-align: center;
          font-size: 17px;
          font-weight: 500;
          color: #1a1a1a;
          margin-right: 32px;
        }
        
        /* Content - 可滚动区域 */
        .profile-content {
          flex: 1;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          padding-bottom: env(safe-area-inset-bottom);
        }
        
        /* Profile Card - 用户信息卡片 */
        .profile-card {
          background: white;
          margin: 12px 16px;
          padding: 16px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 14px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }
        
        .profile-avatar {
          width: 56px;
          height: 56px;
          background: #e8e8e8;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #666;
          flex-shrink: 0;
        }
        
        .profile-info {
          flex: 1;
          min-width: 0;
        }
        
        .profile-name {
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 4px;
        }
        
        .profile-subtitle {
          font-size: 13px;
          color: #666;
          margin-bottom: 6px;
        }
        
        .profile-meta {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 12px;
          color: #999;
        }
        
        .meta-item {
          display: flex;
          align-items: center;
          gap: 4px;
        }
        
        /* Section Card - 通用卡片样式 */
        .section-card {
          background: white;
          margin: 12px 16px;
          padding: 16px;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        }
        
        .section-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 16px;
        }
        
        .section-icon {
          font-size: 16px;
          color: #667eea;
        }
        
        /* Stats Grid - 统计网格 */
        .stats-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        
        .stat-item {
          background: #f8f8f8;
          padding: 12px;
          border-radius: 8px;
          text-align: center;
        }
        
        .stat-item.blue {
          background: #e8f0fe;
        }
        
        .stat-item.green {
          background: #e8f5e9;
        }
        
        .stat-item.yellow {
          background: #fff8e1;
        }
        
        .stat-item.purple {
          background: #f3e5f5;
        }
        
        .stat-number {
          font-size: 22px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 2px;
        }
        
        .stat-label {
          font-size: 12px;
          color: #666;
        }
        
        /* Achievement Items */
        .achievement-item {
          margin-bottom: 16px;
        }
        
        .achievement-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
        }
        
        .achievement-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
        
        .achievement-icon {
          width: 24px;
          height: 24px;
          background: #f0f0f0;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }
        
        .achievement-icon.green {
          background: #e8f5e9;
          color: #4caf50;
        }
        
        .achievement-icon.blue {
          background: #e3f2fd;
          color: #2196f3;
        }
        
        .achievement-desc {
          font-size: 12px;
          color: #999;
          margin-bottom: 6px;
          padding-left: 32px;
        }
        
        .achievement-stat {
          font-size: 13px;
          color: #666;
        }
        
        .progress-bar {
          height: 4px;
          background: #f0f0f0;
          border-radius: 2px;
          overflow: hidden;
          margin-left: 32px;
        }
        
        .progress-fill {
          height: 100%;
          background: #4caf50;
          transition: width 0.3s;
        }
        
        .progress-fill.blue {
          background: #2196f3;
        }
        
        .progress-percent {
          font-size: 13px;
          color: #666;
        }
        
        /* Trip Items */
        .trip-list {
          margin-top: -8px;
        }
        
        .trip-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 0;
          border-bottom: 1px solid #f5f5f5;
        }
        
        .trip-item:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }
        
        .trip-image {
          width: 48px;
          height: 48px;
          background: #e8e8e8;
          border-radius: 8px;
          flex-shrink: 0;
          background-size: cover;
          background-position: center;
        }
        
        .trip-info {
          flex: 1;
          min-width: 0;
        }
        
        .trip-city {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 2px;
        }
        
        .trip-details {
          font-size: 12px;
          color: #999;
        }
        
        .trip-rating {
          display: flex;
          align-items: center;
          gap: 4px;
        }
        
        .rating-stars {
          display: flex;
          gap: 2px;
          margin-right: 4px;
        }
        
        .star {
          color: #ffc107;
          font-size: 12px;
        }
        
        .rating-text {
          font-size: 12px;
          color: #666;
        }
        
        /* Settings Items */
        .setting-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 0;
          border-bottom: 1px solid #f5f5f5;
        }
        
        .setting-item:last-child {
          border-bottom: none;
        }
        
        .setting-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .setting-icon-wrapper {
          width: 32px;
          height: 32px;
          background: #f5f5f5;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #666;
        }
        
        .setting-text {
          font-size: 14px;
          color: #333;
        }
        
        /* Toggle Switch */
        .toggle-switch {
          position: relative;
          width: 48px;
          height: 28px;
          background: #e0e0e0;
          border-radius: 14px;
          cursor: pointer;
          transition: background 0.3s;
        }
        
        .toggle-switch.active {
          background: #4caf50;
        }
        
        .toggle-slider {
          position: absolute;
          width: 24px;
          height: 24px;
          background: white;
          border-radius: 50%;
          top: 2px;
          left: 2px;
          transition: transform 0.3s;
          box-shadow: 0 2px 4px rgba(0,0,0,0.15);
        }
        
        .toggle-switch.active .toggle-slider {
          transform: translateX(20px);
        }
        
        .chevron-right {
          color: #999;
          font-size: 14px;
        }
        
        /* Sign Out Button */
        .signout-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: calc(100% - 32px);
          margin: 20px 16px;
          padding: 14px;
          background: white;
          border: 1px solid #ff4444;
          border-radius: 12px;
          color: #ff4444;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .signout-btn:hover {
          background: #fff5f5;
        }
        
        /* 移动端优化 */
        @media (max-width: 390px) {
          .section-card {
            margin: 10px 12px;
            padding: 14px;
          }
          
          .profile-card {
            margin: 10px 12px;
            padding: 14px;
          }
        }
      `}</style>

            <div className="profile-container">
                {/* Header */}
                <div className="profile-header">
                    <div className="header-bar">
                        <button className="back-btn" onClick={handleBack}>
                            <i className="bi bi-chevron-left"></i>
                        </button>
                        <div className="header-title">My Profile</div>
                    </div>
                </div>

                {/* Scrollable Content */}
                <div className="profile-content">
                    {/* Profile Info */}
                    <div className="profile-card">
                        <div className="profile-avatar">
                            <img
                                src="https://i.pinimg.com/1200x/fd/20/13/fd20135e219e1336b7fdc478dca13d90.jpg" 
                                alt="Profile"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '50%',
                                    objectFit: 'cover'
                                }}
                            />
                        </div>
                        <div className="profile-info">
                            <div className="profile-name">Da pei</div>
                            <div className="profile-subtitle">Travel enthusiast, FIT designer</div>
                            <div className="profile-meta">
                                <div className="meta-item">
                                    <i className="bi bi-geo-alt" style={{ fontSize: '11px' }}></i>
                                    <span>Montreal</span>
                                </div>
                                <div className="meta-item">
                                    <i className="bi bi-calendar3" style={{ fontSize: '11px' }}></i>
                                    <span>Joined Jan 2024</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Travel Stats */}
                    <div className="section-card">
                        <div className="section-title">
                            <i className="bi bi-trophy section-icon"></i>
                            <span>Travel Statistics</span>
                        </div>
                        <div className="stats-grid">
                            <div className="stat-item blue">
                                <div className="stat-number">8</div>
                                <div className="stat-label">Cities Visited</div>
                            </div>
                            <div className="stat-item green">
                                <div className="stat-number">12</div>
                                <div className="stat-label">Trips Done</div>
                            </div>
                            <div className="stat-item yellow">
                                <div className="stat-number">24</div>
                                <div className="stat-label">Places Reviewed</div>
                            </div>
                            <div className="stat-item purple">
                                <div className="stat-number">15</div>
                                <div className="stat-label">Local Friends</div>
                            </div>
                        </div>
                    </div>

                    {/* Achievements */}
                    <div className="section-card">
                        <div className="section-title">
                            <i className="bi bi-award section-icon"></i>
                            <span>Achievements</span>
                        </div>

                        <div className="achievement-item">
                            <div className="achievement-header">
                                <div className="achievement-title">
                                    <div className="achievement-icon green">
                                        <i className="bi bi-globe"></i>
                                    </div>
                                    <span>Montreal Explorer</span>
                                </div>
                                <span className="progress-percent">80%</span>
                            </div>
                            <div className="achievement-desc">Visit 5 districts in Montreal</div>
                            <div className="achievement-stat">8/10</div>
                            <div className="progress-bar">
                                <div className="progress-fill" style={{ width: '80%' }}></div>
                            </div>
                        </div>

                        <div className="achievement-item">
                            <div className="achievement-header">
                                <div className="achievement-title">
                                    <div className="achievement-icon blue">
                                        <i className="bi bi-star"></i>
                                    </div>
                                    <span>Review Expert</span>
                                </div>
                                <span className="progress-percent">104%</span>
                            </div>
                            <div className="achievement-desc">Write 50 helpful reviews</div>
                            <div className="achievement-stat">52/50</div>
                            <div className="progress-bar">
                                <div className="progress-fill blue" style={{ width: '100%' }}></div>
                            </div>
                        </div>
                    </div>

                    {/* Recent Trips */}
                    <div className="section-card">
                        <div className="section-title">
                            <i className="bi bi-airplane section-icon"></i>
                            <span>Recent Trips</span>
                        </div>
                        <div className="trip-list">
                            <div className="trip-item">
                                <div className="trip-image" style={{
                                    backgroundImage: 'url(https://images.unsplash.com/photo-1519178614-68673b201f36?w=100&h=100&fit=crop)'
                                }}></div>
                                <div className="trip-info">
                                    <div className="trip-city">Montreal</div>
                                    <div className="trip-details">Dec 2024 • 5 days</div>
                                </div>
                                <div className="trip-rating">
                                    <div className="rating-stars">
                                        {[1, 2, 3, 4, 5].map(i => (
                                            <i key={i} className="bi bi-star-fill star"></i>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="trip-item">
                                <div className="trip-image" style={{
                                    backgroundImage: 'url(https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100&h=100&fit=crop)'
                                }}></div>
                                <div className="trip-info">
                                    <div className="trip-city">Quebec City</div>
                                    <div className="trip-details">Nov 2024 • 3 days</div>
                                </div>
                                <div className="trip-rating">
                                    <div className="rating-stars">
                                        {[1, 2, 3, 4].map(i => (
                                            <i key={i} className="bi bi-star-fill star"></i>
                                        ))}
                                        <i className="bi bi-star star" style={{ color: '#ddd' }}></i>
                                    </div>
                                </div>
                            </div>

                            <div className="trip-item">
                                <div className="trip-image" style={{
                                    backgroundImage: 'url(https://images.unsplash.com/photo-1517090504586-fde19ea6066f?w=100&h=100&fit=crop)'
                                }}></div>
                                <div className="trip-info">
                                    <div className="trip-city">Toronto</div>
                                    <div className="trip-details">Oct 2024 • 4 days</div>
                                </div>
                                <div className="trip-rating">
                                    <div className="rating-stars">
                                        {[1, 2, 3, 4, 5].map(i => (
                                            <i key={i} className="bi bi-star-fill star"></i>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Settings */}
                    <div className="section-card">
                        <div className="section-title">
                            <i className="bi bi-gear section-icon"></i>
                            <span>Settings</span>
                        </div>

                        <div className="setting-item">
                            <div className="setting-left">
                                <div className="setting-icon-wrapper">
                                    <i className="bi bi-bell"></i>
                                </div>
                                <span className="setting-text">Push Notifications</span>
                            </div>
                            <div
                                className={`toggle-switch ${pushNotifications ? 'active' : ''}`}
                                onClick={() => setPushNotifications(!pushNotifications)}
                            >
                                <div className="toggle-slider"></div>
                            </div>
                        </div>

                        <div className="setting-item">
                            <div className="setting-left">
                                <div className="setting-icon-wrapper">
                                    <i className="bi bi-geo-alt"></i>
                                </div>
                                <span className="setting-text">Location Sharing</span>
                            </div>
                            <div
                                className={`toggle-switch ${locationSharing ? 'active' : ''}`}
                                onClick={() => setLocationSharing(!locationSharing)}
                            >
                                <div className="toggle-slider"></div>
                            </div>
                        </div>

                        <div className="setting-item">
                            <div className="setting-left">
                                <div className="setting-icon-wrapper">
                                    <i className="bi bi-shield-check"></i>
                                </div>
                                <span className="setting-text">Privacy Settings</span>
                            </div>
                            <i className="bi bi-chevron-right chevron-right"></i>
                        </div>

                        <div className="setting-item">
                            <div className="setting-left">
                                <div className="setting-icon-wrapper">
                                    <i className="bi bi-question-circle"></i>
                                </div>
                                <span className="setting-text">Help & Support</span>
                            </div>
                            <i className="bi bi-chevron-right chevron-right"></i>
                        </div>
                    </div>

                    {/* Sign Out Button */}
                    <button className="signout-btn">
                        <i className="bi bi-box-arrow-right"></i>
                        <span>Sign Out</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Profile;